/** 120 → "2h", 90 → "1h 30m", 45 → "45m", 0 → "0m". */
export const gapDuration = (minutes) => {
  const m = Math.max(0, Math.round(Number(minutes) || 0));
  const h = Math.floor(m / 60);
  if (!h) return `${m}m`;
  return m % 60 ? `${h}h ${m % 60}m` : `${h}h`;
};

/** "Client A to Client B", "From Client A", "To Client B", or "". */
export const gapRoute = ({ fromClient, toClient } = {}) => {
  if (fromClient && toClient) return `${fromClient} to ${toClient}`;
  if (fromClient) return `From ${fromClient}`;
  if (toClient) return `To ${toClient}`;
  return "";
};
